import React, { useCallback, useEffect, useState } from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import { colors } from "src/assets";
import { useNavigation } from "@react-navigation/native";
import { Typography, BottomActions, Button } from "src/components";
import { useCognito } from "src/hooks";
import LocalText from "src/local";
import { RootStackScreenProps } from "src/navigation/types";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import axios from "axios";
import { paymentEndpoint } from "src/aws-config";
import { transactionCreditCardEmit } from "src/utils/event";

export type CreditCardNavigationParam = undefined;

export type StackParamList = {
  CreditCard: CreditCardNavigationParam;
};

export const CreditCardScreen: React.FC = () => {
  const navigation =
    useNavigation<RootStackScreenProps<"CreditCard">["navigation"]>();
  const stripe = useStripe();
  const elements = useElements();
  const [username] = useCognito();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>();

  const registerHandler = useCallback(async () => {
    if (!stripe || !elements || !username) {
      return;
    }
    const cardElement = elements.getElement(CardElement);

    if (!cardElement) {
      return;
    }

    setLoading(true);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
    });

    if (paymentMethod) {
      await axios.post(`${paymentEndpoint}/${username}/save-payment-method`, {
        paymentMethodId: paymentMethod.id,
      });
      transactionCreditCardEmit();
      navigation.goBack();
    } else {
      setError(error.message || "An error occurred");
      console.log("error", error);
      alert("Error");
    }
    setLoading(false);
  }, [stripe, elements, username, navigation]);

  return (
    <View style={styles.root}>
      <ScrollView style={styles.scrollView}>
        <Typography
          text={LocalText.screens.creditCard.creditCard}
          variant={"section"}
        />
        <View
          style={{
            backgroundColor: "#FFFFFF",
            paddingHorizontal: 16,
            paddingVertical: 4,
          }}
        >
          <CardElement options={{ hidePostalCode: true }} />
          {error && (
            <div style={{ color: "red", marginTop: "12px" }}>{error}</div>
          )}
        </View>
      </ScrollView>
      <BottomActions>
        <Button
          variant={"secondary"}
          icon={"chevron"}
          iconColor={colors.chokuRed}
          iconSize={12}
          title={LocalText.common.back}
          onPress={() => navigation.goBack()}
        />

        <Button
          variant={"primary"}
          loading={loading}
          title={LocalText.screens.creditCard.register}
          onPress={registerHandler}
        />
      </BottomActions>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    flexDirection: "column",
    backgroundColor: colors.gray1,
  },
  scrollView: {
    flex: 1,
  },
  banner: {
    marginHorizontal: 16,
    marginVertical: 8,
  },
  footer: {
    paddingTop: 0,
  },
  formGroup: {
    marginVertical: 8,
  },
});
